module.exports = __webpack_public_path__ + "static/media/TricoConference.154aa813.jpg";